import { apiRequest, buildHeaders } from "@bkry/bowline-utils";
import { call, put, takeEvery } from "redux-saga/effects";
import { actions } from "./index";

export function* create(action) {
  let headers = yield buildHeaders();
  const { successCallback, tmpFileData, values, projectId } = action.payload;
  try {
    const payload = yield call(
      apiRequest,
      `/api/v1/projects/${projectId}/tmp_files`,
      {
        body: JSON.stringify(action.payload.values),
        method: "POST",
        headers,
      }
    );
    if (successCallback) successCallback(payload.data.id);
    yield put(actions.createSuccess(payload.data));
  } catch (e) {
    console.error(e);
    yield put(actions.createFail({ message: e.message, ...e }));
  }
}

/**
 * Saga Watchers
 * The exported list of sagas registered. When one of the action types is dispatched
 * the related worker saga is invoked.
 * Each saga is executed in a different thread
 */
function* tmpFilesSaga() {
  yield takeEvery(actions.create, create);
}
export default tmpFilesSaga;
